import React from 'react'
import { Link } from 'react-router-dom';

const ReviewPage = () => {
  return (
    <>

      <div className="review-body d-flex justify-content-center align-items-center" style={{ height: "100vh", background: " radial-gradient(88.22% 88.22% at 50% 0%, rgba(11, 90, 98, 0.8) 0%, rgba(7, 67, 75, 0) 100%), #000B0C" }}>


        <Link to='/playerscreen'>

          <button style={{ borderRadius: "20px", border: "none" }}>Player Screen</button>

        </Link>

        <Link className='mx-3' to='/playerwaiting'>

          <button style={{ borderRadius: "20px", border: "none" }}>Player Waiting</button>

        </Link>
        <Link className='mx-3' to='/slpash'>

          <button style={{ borderRadius: "20px", border: "none" }}>Splash Screen</button>

        </Link>
        <Link className='mx-3' to='/today-prize'>

          <button style={{ borderRadius: "20px", border: "none" }}>TodayPrizes Screen</button>

        </Link>
        <Link className='mx-3' to='/challange'>

          <button style={{ borderRadius: "20px", border: "none" }}>Challange Screen</button>

        </Link>
        <Link className='mx-3' to='/leaderboard'>

          <button style={{ borderRadius: "20px", border: "none" }}>Leader Board</button>


        </Link>

      </div>

    </>
  )
}

export default ReviewPage